import React from "react"
import ReactDOM from "react-dom"
import SupportPanel from "./support-panel-component"

export default class SupportPanelModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<SupportPanel {...self.modelJson} />, self.elem)
  }
}
